import React from 'react'
import PropTypes from 'prop-types'

import { Title20 } from 'components/Typography'
import {
  WeChatModalInnerContainer,
  WeChatImg,
} from './WeChatContactModal.style'

// forwardRef doesnt accept propTypes, hence this is disabled
// eslint-disable-next-line react/prop-types
const WeChatContactModal = ({ weChatImage, weChatID }) => {
  return (
    <WeChatModalInnerContainer>
      {weChatImage ? (
        <WeChatImg
          image={
            weChatImage?.portrait?.gatsbyImageData ||
            weChatImage?.landscape?.gatsbyImageData
          }
          alt="WeChat QR Code"
        />
      ) : null}
      {weChatID ? <Title20>{`WeChat ID: ${weChatID}`}</Title20> : null}
    </WeChatModalInnerContainer>
  )
}

WeChatContactModal.propTypes = {
  weChatImage: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.object])),
  weChatID: PropTypes.string,
}

WeChatContactModal.defaultProps = {
  weChatImage: {},
  weChatID: '',
}

export default WeChatContactModal
